import {on} from 'delegated-events'

const submittedConfirmationForms = new WeakSet<HTMLFormElement>()

on(
  'submit',
  '.js-copilot-model-default-off-confirmation-form',
  event => {
    const form = event.currentTarget as HTMLFormElement
    const confirmationContainer = form.closest<HTMLElement>('[data-model-default-off-confirmation-enabled]')

    if (confirmationContainer?.getAttribute('data-model-default-off-confirmation-enabled') !== 'true') return

    if (submittedConfirmationForms.has(form)) {
      event.preventDefault()
      return
    }

    submittedConfirmationForms.add(form)
  },
  {capture: true},
)
